import { FreeplayGame, GameLeaderboardDataReturn, GamesApi } from "@freeplay/shared-code";

export class GamesAPIWrapper {
    private ready: Promise<boolean>;
    private readyResolve!: (value: boolean) => void;

    private api!: GamesApi;
    private token!: string;
    private tenantSlug!: string;

    constructor() {
        this.ready = new Promise((resolve) => {
            this.readyResolve = resolve;
        });
    }

    public init(api: GamesApi, token: string, tenantSlug: string): void {
        this.api = api;
        this.token = token;
        this.tenantSlug = tenantSlug;
        this.readyResolve(true);
    }

    public clearUser(): void {
        this.token = "";
    }

    public async getAllGames(): Promise<FreeplayGame[]> {
        await this.ready;
        return await this.api.gamesControllerV1GetAllActiveGames(this.tenantSlug);
    }

    public async getOneGame(id: number): Promise<FreeplayGame> {
        await this.ready;
        return await this.api.gamesControllerV1GetOneGame(id, this.tenantSlug);
    }

    public async getGameLeaderboard(id: number): Promise<GameLeaderboardDataReturn[]> {
        await this.ready;
        return await this.api.gamesControllerV1GetLeaderboardForGame(id, this.tenantSlug);
    }

    private getOptions() {
        return {
            headers: {
                Authorization: `Bearer ${this.token}`,
            },
        };
    }
}
